module.exports = __webpack_public_path__ + "img/Group 183.2bc65735.svg";